import ArticleBox from './articleBox';
import Pagination from './pagination';
import { parseArticle } from '../../utils/helpers';

function ContentSide({ articles, articlesCount, limit, skip, onPageChanged }) {
	return (
		<div className="column is-two-thirds">
			{articles && articles.length > 0 ? (
				articles.map((article, index) => (
					<ArticleBox key={index} {...parseArticle(article)} />
				))
			) : (
				<ArticleBox
					slug="#"
					title="No Posts available"
					date={new Date().toISOString()}
					description="There are no available posts yet"
				/>
			)}
			<Pagination
				totalRecords={articlesCount}
				pageLimit={limit}
				pageNeighbours={3}
				onPageChanged={onPageChanged}
			/>
		</div>
	);
}

export default ContentSide;
